import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSalesAndBillinginline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.278,
			d: "M14.167 5h1.666c.92 0 1.667.746 1.667 1.667v9.166c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.746-1.667-1.667V6.667C2.5 5.747 3.246 5 4.167 5h1.666M17.5 14.167h-15"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.278,
			d: "M5.833 7.5V2.776c0-.315.178-.603.46-.744l.549-.276a.83.83 0 0 1 .743-.003l1.03.51h-.004l1.02-.508a.83.83 0 0 1 .746.001l1.008.506 1.03-.509a.83.83 0 0 1 .744.002l.549.276c.281.142.459.43.459.745V7.5z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.278,
			d: "M13.333 10.833H6.667"
		})
	]
});
export default SvgSalesAndBillinginline;
